import { Module } from 'vuex'
import { RootState, Collection } from '../store-types'
import { MetaPayload } from '@/core/utils/pagination'
import { useTrainingProgramExecutionHttp } from '@/core/api/training-program-executions'
import { TrainingProgramExecution, TrainingProgramExecutionPayload } from '@/core/models/training-program-execution'

export type ProgramExecutionCollection = {
    data: Array<TrainingProgramExecution>,
    meta?: MetaPayload,
    links?: any
}

const state: ProgramExecutionCollection = {
    data: <any>[],
    meta: <any>[],
    links: <any>[],
}

export const programExecutionCollection: Module<ProgramExecutionCollection, RootState> = {
    namespaced: true,
    state,
    mutations: {
        set: (state: ProgramExecutionCollection, payload: Collection) => {
            state.data = <any>[]
            payload.data.forEach((item: TrainingProgramExecutionPayload) => {
                state.data.push(new TrainingProgramExecution(item))
            })
            state.meta = payload.meta
            state.links = payload.links
        },
    },
    actions: {
        get: <T>(context: any, payload: any): Promise<T> => {
            return new Promise<T>((resolve, reject) => {
                useTrainingProgramExecutionHttp()
                    .get(payload)
                    .then((data: any) => {
                        context.commit('set', data)
                        resolve(data as T)
                    })
                    .catch((response: any) => {
                        reject(response as T)
                    })
            })
        }
    },
    getters: {
        get: (state: ProgramExecutionCollection): ProgramExecutionCollection => {
            return state
        }
    }
}